export const getPurchaseType = (purchase: { fz: string }): string => {
  let fz: string;
  if (purchase?.fz === "commerce") {
    fz = "Коммерческая Закупка ";
  } else {
    fz = `Закупка по ${purchase?.fz}-ФЗ`;
  }
  return fz;
};
